$(document).foundation();

jQuery(document).ready(function($) {

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  });

  // mobile nav
  $(".small-navigation-trigger").on("click", function() {
    $('body').addClass('mobile-nav-opened');
  });
  $(".small-navigation-close, .small-navigation ul li a").on("click", function() {
    $('body').removeClass('mobile-nav-opened');    
  });

  // adjust margin-top of main depending on floating header
  var $header = $('header');
  var $main = $('main');
  var $window = $(window);
  $window.on('resize', function() {
    $main.css({'margin-top': $header.outerHeight()});
  });

  // on scroll change header class
  var $headerScroll = $('.header-container');
  if ($headerScroll.length > 0) {
    $window.on("scroll", function() {
      var offset = 92;
      if ($window.scrollTop() > offset) {
        $('body').addClass('nav-condensed');
      } else {
        $('body').removeClass('nav-condensed');
      }
    });
  }

  function activateItemIntoView(itemId) {
    var $item = $("#"+itemId);
    var headerHeight = 64; // assume item is so below that nav has condensed due to scrolling
    if ($item.is('.title-container') || $item.is('section')) {
      $('.reveal').foundation('close');
      $('html,body').animate({scrollTop: $item.offset().top - headerHeight - 24}, 'slow');
    } else if ($item.is('.reveal')) {
      $('[data-open="'+itemId+'"]').eq(0).trigger("click");
    }
  }

	$(window).on("load", function() {
		var urlHash = window.location.hash;
		if (urlHash) {
      urlHash = urlHash.substring(1);
      activateItemIntoView(urlHash);
    }
	});

  // handle internal links
  $("a[href^='#']").on("click", function(e) {
    e.preventDefault();
    var itemId = $(this).attr('href').substring(1);
    activateItemIntoView(itemId);
  });

  // copy to clipboard
  $('[href="#copy-to-clipboard"]').on("click", function(e) {
    e.preventDefault();
    var $temp = $("<input>");
    var $button = $(this);
    $("body").append($temp);
    $temp.val($button.data('copy-text')).select();
    document.execCommand("copy");
    $temp.remove();
    $button.parent().foundation("show");
    setTimeout(function() {
      $button.parent().foundation("hide");
    }, 2000);
  });

  //drop cap first paragraph
  $('.drop-cap-first-p').each(function() {
    var $current = $(this);
    var $firstP = $current.find('p').eq(0);
    if ($firstP.length > 0) {
      var tempContent = $firstP.html();
      var firstLetter = tempContent[0];
      var finalContent = '<span class="drop-cap">' + firstLetter + '</span>' + tempContent.substr(1);
      $firstP.html(finalContent);
    }
  });

  // debugger
  $window.on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
